import BusinessCardImportsAPI from 'dashboard/api/businessCardImports';

const state = {
  records: [],
  currentImport: null,
  entries: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isCommitting: false,
  },
  meta: {
    total: 0,
    page: 1,
    per_page: 20,
  },
};

const getters = {
  getRecords: $state => $state.records,
  getCurrentImport: $state => $state.currentImport,
  getEntries: $state => $state.entries,
  getUIFlags: $state => $state.uiFlags,
  getMeta: $state => $state.meta,
};

const actions = {
  async fetch({ commit }, { params = {} } = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await BusinessCardImportsAPI.index({ params });
      commit('SET_RECORDS', response.data);
      commit('SET_UI_FLAG', { isFetching: false });
    } catch (error) {
      commit('SET_UI_FLAG', { isFetching: false });
      throw error;
    }
  },

  async fetchOne({ commit }, { importId }) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await BusinessCardImportsAPI.show({ importId });
      commit('SET_CURRENT_IMPORT', response.data.business_card_import);
      commit('SET_ENTRIES', response.data.business_card_entries || []);
      commit('SET_UI_FLAG', { isFetching: false });
    } catch (error) {
      commit('SET_UI_FLAG', { isFetching: false });
      throw error;
    }
  },

  async create({ commit }, { fileIds }) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await BusinessCardImportsAPI.create({ fileIds });
      commit('SET_UI_FLAG', { isCreating: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isCreating: false });
      throw error;
    }
  },

  async update({ commit }, { importId, payload }) {
    try {
      await BusinessCardImportsAPI.update({ importId, payload });
    } catch (error) {
      throw error;
    }
  },

  async commit({ commit }, { importId, entryIds, tags = [] }) {
    commit('SET_UI_FLAG', { isCommitting: true });
    try {
      const response = await BusinessCardImportsAPI.commit({
        importId,
        entryIds,
        tags,
      });
      commit('SET_UI_FLAG', { isCommitting: false });
      return response.data;
    } catch (error) {
      commit('SET_UI_FLAG', { isCommitting: false });
      throw error;
    }
  },

  async destroy({ commit }, { importId }) {
    try {
      await BusinessCardImportsAPI.destroy({ importId });
    } catch (error) {
      throw error;
    }
  },
};

const mutations = {
  SET_RECORDS($state, data) {
    $state.records = data;
  },

  SET_CURRENT_IMPORT($state, importData) {
    $state.currentImport = importData;
  },

  SET_ENTRIES($state, entries) {
    $state.entries = entries;
  },

  UPDATE_ENTRY($state, { entryId, updates }) {
    const index = $state.entries.findIndex(e => e.id === entryId);
    if (index !== -1) {
      $state.entries[index] = { ...$state.entries[index], ...updates };
    }
  },

  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },

  SET_META($state, meta) {
    $state.meta = { ...$state.meta, ...meta };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
